<template>
  <div class="outer-container">

    <h1>{{displayDate}}</h1>

    <Loading :show="loading" />
    <router-view @reload="fetch(true)"></router-view>

    <div class="inner-container" v-if="!loading">

      <div class="snowflake"></div>

    <p class="booking-id text-sm">
      Bokningsnummer: {{ order.resvid }}
    </p>

      <!-- Accommodation -->
      <div v-if="orderTypeSingle === 'accomodation'" class="accomodation-outer">
        <div class="accomodation-rows">
          <div v-for="row in order.details.rows.accomodation" :key="row.rowid">
            <div v-if="row.accommodation" class="accommodation">
              <div class="accommodation-image" :style="(row.accommodation.image || (row.accommodation.pool && row.accommodation.pool.image) ) ? 'background-image:url(' + (row.accommodation.image || (row.accommodation.pool && row.accommodation.pool.image) ) + ')' : 'background-size: cover;'">
              </div>

              <div class="booking-facts">
                <p class="booking-title">
                  {{ row.accommodation.display_name || row.accommodation.description_title }}<span v-if="row.accommodation.subtitle"> – {{row.accommodation.subtitle}}</span>
                </p>

                <p class="arrival-date">
                  {{[order.details.firstDate, order.details.lastDate] | dateRange('long', ' – ')}}
                </p>

                <div style="margin-top: 1.5rem;">
                  Incheckning: {{row.accommodation.check_in_time}}<br />
                  Utcheckning: {{row.accommodation.check_out_time}}
                </div>

                <div v-if="SITE_CONFIG.settings.SettingLockTypes.active && row.accommodation.lock_type_id" style="margin-top: 0.5rem;">
                  {{ SITE_CONFIG.settings.SettingLockTypes.texts[row.accommodation.lock_type_id].title }}: {{ SITE_CONFIG.settings.SettingLockTypes.texts[row.accommodation.lock_type_id].description }}
                </div>

                <div style="margin-top: 2rem;margin-bottom: 1rem;">
                  <UnitFacts :unit="row.accommodation" :small="true" />
                </div>
              </div>

              <!-- <div class="accommodation-facts">

                Tillvalslista
                <div v-if="order.details.can_add_to_booking && SITE_CONFIG.add_to_booking_open">
                  <button class="white border button-override" @click.stop="bookAddon(row)">Boka tillval</button>
                </div>
              </div>
            </div> -->
            </div>
          </div>
        </div>

        <div class="links only-large-screen">
          <a :href="link.url" v-for="(link, key) in links(1)" v-bind:key="'links1-' + key">{{link.title}}</a>
        </div>
      </div>

      <div v-if="orderTypeSingle !== 'accomodation'">
          <div class="other">
            <div class="other-image" :style="'background-image:url(' + 'https://cdn.branasgruppen.se/branas/app/uploads/2023/10/27141148/familjmedskidor_hero.jpg' + ');'">
            </div>

            <div class="booking-facts">
              <div>
              <p class="booking-title">
                {{ orderTypeVisual }}
              </p>

              <p class="arrival-date">
                {{[order.details.firstDate, order.details.lastDate] | dateRange('long', ' – ')}}
              </p>
              </div>
            </div>

            <div class="links only-large-screen">
              <a :href="link.url" v-for="(link, key) in links(1)" v-bind:key="'links1-' + key">{{link.title}}</a>
            </div>
          </div>
        </div> 

      <!-- Checkboxes -->
      <div class="booking-checkboxes">
        <div v-for="cat in categories" :key="cat.slug" class="row-wrap">
          <div class="row-header">
            <div class="checkbox">
              <Checkbox label="" label-position="right" :value="cat.has"></Checkbox>
            </div>
            <div class="category">{{ cat.title }}</div>
            <div class="actions" v-if="cat.slug === 'rental'">
              <button v-if="cat.has" class="button--rounded--outlined" @click.stop="openRental = !openRental">{{ openRental ? 'Dölj' : 'Visa' }}</button>
              <button v-if="!cat.has" class="button--rounded" @click.stop="bookMoreWithLink(cat.link, order)">Boka nu</button>
            </div>
            <div class="actions" v-if="cat.slug === 'skipass'">
              <button v-if="cat.has" class="button--rounded--outlined" @click.stop="openSkipass = !openSkipass">{{ openSkipass ? 'Dölj' : (showQrCodeButton ? 'Visa mer, QR-koder' : '') }}</button>
              <button v-if="!cat.has" class="button--rounded" @click.stop="bookMoreWithLink(cat.link, order)">Boka nu</button>
            </div>
            <div class="actions" v-if="cat.slug === 'skischool'">
              <button v-if="cat.has" class="button--rounded--outlined" @click.stop="openSkischool = !openSkischool">{{ openSkischool ? 'Dölj' : 'Visa' }}</button>
              <button v-if="!cat.has" class="button--rounded" @click.stop="bookMoreWithLink(cat.link, order)">Boka nu</button>
            </div>
            <div class="actions" v-if="cat.slug === 'accomodation'">
              <button v-if="cat.has" class="button--rounded--outlined" @click.stop="goToAccommodation(cat.product_slug)">Visa</button>
              <button v-if="!cat.has" class="button--rounded" @click.stop="bookMoreWithLink(cat.link, order)">Boka nu</button>
            </div>
          </div>
          <div class="row-content">
            <button v-if="openSkipass && cat.slug === 'skipass' && showQrCodeButton" @click="openQrModal" class="button--rounded--outlined qr-button">QR-koder till liftkortsautomat</button>
            <PrettyOrderDetails :order="order" :types="[cat.slug]" variant="mini" :openRental="openRental" :openSkipass="openSkipass" :openSkischool="openSkischool" :key="cat.slug + 'pod' + (new Date())" :bookMoreCallback="bookMore" />
          </div>
        </div>
      </div>

      <div class="links only-small-screen">
        <a :href="link.url" v-for="(link, key) in links(1)" v-bind:key="'links1-' + key">{{link.title}}</a>
      </div>

      <!-- Addons -->
      <div v-if="addons.length">
        <div class="addon-title">
          <h2>Populära tillval</h2>
        </div>
        <div class="booking-checkboxes booking-checkboxes--addons">
          <div v-for="addon in addons" :key="addon.lid" class="row-wrap">
            <div class="row-header">
              <div class="checkbox">
                <Checkbox label="" label-position="right" :value="hasAddons.indexOf(addon.lid) !== -1"></Checkbox>
              </div>
              <div class="category">{{ addon.arttext }}</div>
              <div class="actions">
                <button v-if="!addon.added" class="button--rounded--outlined" @click.stop="bookAddon()">Boka</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="info-box" style="margin: 4rem 0 2rem 0;">
        Vid ändringar kontakta gästservice på 054-13 26 00
      </div>

      <div class="center" style="margin: 4rem 2rem 2rem 2rem;">
        <button class="button--rounded" @click.stop="goToBooking(order.headlid)">Fler detaljer</button>
      </div>

    </div>

      <div class="outer-links">
        <div v-for="(link, key) in links(2)" v-bind:key="'links2-' + key">
          <div class="icon-wrapper"><icon name="arrow-white" :scale="0.7"></icon></div>
          <a :href="link.url">{{link.title}}</a>
        </div>
      </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

import Cart from '@/components/parts/Cart';
import Timeline from '@/components/components/Timeline';
import CompletedBookings from '@/components/parts/CompletedBookings';
import Modal from '@/components/components/Modal';
import Loading from '@/components/components/Loading';
import UnitFacts from '@/components/parts/Accomodation/UnitFacts';
import Checkbox from '@/components/components/Checkbox-v2';
import PrettyOrderDetails from '@/components/components/PrettyOrderDetails';

import myOrder from '@/mixins/my-order'; // eslint-disable-line

import API from '@/classes/API';

import moment from 'moment';

export default {
  components: {
    Cart,
    Timeline,
    CompletedBookings,
    Modal,
    Loading,
    UnitFacts,
    Checkbox,
    PrettyOrderDetails,
  },
  data() {
    return {
      loading: true,
      loadingAddons: true,
      order: {},
      categories: {},
      accomodation: null,
      hasAddons: [],
      openRental: false,
      openSkipass: false,
      openSkischool: false,
      addons: [],
    };
  },
  computed: {
    displayDate() {
      if (this.loading) {
        return 'Laddar...';
      }

      const arrival = moment(this.order.details.firstDate);
      const departure = moment(this.order.details.lastDate);
      const today = moment();
      const diff = departure.diff(arrival, 'days');
      const todayDiff = Math.abs(today.diff(arrival, 'days'));

      if (this.order.status === 'active') {
        return `Dag ${todayDiff + 1} av ${diff + 1}...`;
      } else if (this.order.status === 'upcoming') {
        if (todayDiff <= 30) {
          return `Bara ${todayDiff + 1} dagar kvar...`;
        }
        return `Bara ${todayDiff + 1} dagar kvar...`;
      }

      return 'Din resa';
    },
    showQrCodeButton() {
      if (this.loading) {
        return false;
      }

      if (!this.order) {
        return false;
      }

      if (!this.order.details) {
        return false;
      }

      if (!this.order.details.qrCodes) {
        return false;
      }

      if (this.order.details.qrCodes.length === 0) {
        return false;
      }

      return true;
    },
    hasValidCodes() {
      return this.order.details.qrCodes.map(code => !!code.ordernumber)
        .filter(code => code).length > 0;
    },
    hasCodes() {
      return this.order.details.qrCodes.length > 0;
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal',
    ]),
    openQrModal() {
      this.openModal([
        'QrModal', {
          order: this.order.details,
        },
      ]);
    },
    /* eslint-disable */
    links(id) {
      let allLinks = this.SITE_CONFIG.settings[`mypages-links${id}`];

      let newLinks = [];

      let currentTypes = this.orderTypes;

      for (let i = 0; i < allLinks.length; i++) {
        let categories = allLinks[i].categories;

        for (let ii in categories) {
          if (currentTypes.indexOf(categories[ii]) !== -1) {
            newLinks.push(allLinks[i]);
            break;
          }
        }
      }

      return newLinks;
    },
    /* eslint-enable */
    async fetch() {
      this.loading = true;
      const { data } = await API.get(`/order-v2/${this.$route.params.bookingNumber}`);
      this.order = data;
      this.loading = false;

      const categories = {
        skipass: {
          title: 'Liftkort',
          has: false,
          slug: 'skipass',
          product_slug: '',
          link: '/liftkort?quick=1',
        },
        skischool: {
          title: 'Skidskola',
          has: false,
          slug: 'skischool',
          product_slug: '',
          link: '/skidskola/oversikt',
        },
        rental: {
          title: 'Utrustning',
          has: false,
          slug: 'rental',
          product_slug: '',
          link: '/skidhyra',
        },
        accomodation: {
          title: 'Boende',
          has: false,
          slug: 'accomodation',
          product_slug: '',
          link: '/boenden',
        },
      };

      Object.keys(this.order.details.rows).forEach((row) => {
        if (categories[row]) {
          categories[row].has = true;

          if (!categories[row].product_slug && row === 'accomodation') {
            categories[row].product_slug =
              this.order.details.rows.accomodation[0].accommodation.slug;
            this.accomodation = this.order.details.rows.accomodation[0];
          }
        }
      });

      this.categories = Object.values(categories);

      if (this.accomodation) {
        this.fetchAddons();
      }

      this.addons = [];
      if (this.order.details.rows.addon) {
        this.hasAddons = this.order.details.rows.addon.map(addon => `${addon.pool}`);
      }
    },
    fetchAddons() {
      const a = this.accomodation.accommodation;
      const arrival = this.accomodation.date_arrival.substr(0, 10);
      const departure = this.accomodation.date_departure.substr(0, 10);

      API.get(`/units/${a.pool_lid}/${a.unit_lid}/addons/${arrival}/${departure}?for-order=${this.order.resvid}`).then((response) => {
        this.addons = [];

        if (response.cancellationInsurance) {
          this.addons.push(response.cancellationInsurance);
        }
        if (response.lateArrival) {
          this.addons.push(response.lateArrival);
        }
        response.data.forEach((addon) => {
          this.addons.push(addon);
        });
        response.groceryBags.forEach((addon) => {
          this.addons.push(addon);
        });
      });
    },
    goToBooking(number) {
      const currentUri = encodeURI(this.$route.path);
      this.$router.push(`/mina-sidor/resa/${number}/detaljer?flow=${currentUri}`);
    },
    goToAccommodation(slug) {
      const url = this.$route.path.substr(1);
      this.$router.push({ path: `/mina-sidor/resa/${this.order.headlid}/boende/${slug}?flow=${url}` });
    },
    bookMoreWithLink(link, localOrder) {
      this.$store.state.cart.addToOrder = {
        number: localOrder.resvid,
        numeric: localOrder.headlid,
        dateStart: localOrder.details.dateStart,
        dateEnd: localOrder.details.dateEnd,
        hasAccommodation: !!this.accomodation,
      };

      this.$router.push(link);
    },
    bookMore(bookingType, localOrder) {
      const category = this.categories.find(cat => cat.slug === bookingType);

      this.bookMoreWithLink(category.link, localOrder);
    },
    bookAddon() {
      const row = this.accomodation;

      this.$store.state.cart.addToOrder = {
        number: this.order.resvid,
        numeric: this.order.headlid,
        accomodationRow: row.row,
        accomodationName: row.name,
        accomodationDateArrival: row.arrival,
        accomodationDateDeparture: row.departure,
        accomodationGroup: row.group,
      };

      this.$router.push({
        name: 'addons extra',
        query: {
          pool: row.pool,
          unit: row.unit,
          arrival: row.arrival,
          departure: row.departure,
          name: row.name,
          adults: parseInt(row.adults, 10),
          youths: parseInt(row.youths, 10),
          children: parseInt(row.children, 10),
          seniors: parseInt(row.seniors, 10) || 0,
        },
      });
    },
  },
  mounted() {
    this.fetch();
  },
  mixins: [myOrder],
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'
@import '~@/global-v2.styl'

.outer-container
  background-color light-blue
  min-height: 100vh
  background-image linear-gradient(180deg, transparent 0%, light-blue 25rem, light-blue 100%), url(https://cdn.branasgruppen.se/branas/app/uploads/2021/12/15163206/branas-barnsemester-1.jpg);
  background-size 100vw auto
  background-repeat no-repeat
  background-position: center top 

h1
  big-title()
  color theme-blue
  text-align left
  text-transform none
  margin 0
  padding 0
  padding-left 1rem
  padding-top 4rem
  padding-bottom 6rem
  @media (max-width: 1000px)
    padding-bottom 2rem

.inner-container
  max-width: 1108px
  width 100%
  padding 3rem 7rem
  background-color white
  margin 0 auto
  position relative
  overflow hidden
  @media (max-width: 1000px)
    padding 2rem 2rem
  & > *
    z-index: 1
    position relative
  .snowflake
    background-image url(https://www.branas.se/app/themes/branasgruppen-core/assets/images/icons/snowflake-icon.svg)
    background-size contain
    background-repeat no-repeat
    background-position center
    position absolute
    width: 24rem
    height 24rem
    right -6rem
    top 6rem
    opacity 0.2
    z-index 0

.accomodation-outer
  display flex
  .accomodation-rows
    width calc(100% - 120px)
    @media(max-width: 1000px)
      width 100%

.links
  width 120px
  padding-top 2rem
  font-size 0.875rem
  &.only-large-screen
    display: block
    @media (max-width: 1000px)
      display none
  &.only-small-screen
    display none
    @media (max-width: 1000px)
      display block
  a
    display: block
    margin-bottom: 0.25rem
    color theme-blue

.outer-links
  max-width 638px
  width 100%
  display flex
  margin 3rem auto 0 auto
  padding-bottom 6rem
  flex-wrap wrap
  @media(max-width 450px)
    padding-left 2rem
    padding-right 2rem
    margin-left 0
    margin-right 0
    flex-direction: column

  & > div
    display: block
    margin-bottom: 0.5rem
    width 50%
    display flex
    align-items: center
    a
      color theme-blue
  div.icon-wrapper
    background-color theme-blue
    border-radius 50%
    display inline-block
    width: 1.5rem
    height: 1.5rem
    display inline-flex
    justify-content center
    align-items: center
    margin-bottom auto
    margin-right 0.5rem

.accommodation, .other
  display flex
  @media (max-width: 700px)
    flex-direction: column

.accommodation-image, .other-image
  width 180px
  padding-top: 120px
  background-size: cover
  background-position: center
  @media (max-width: 700px)
    width 100% !important
.accommodation-image
  width 336px
  padding-top 224px

.booking-facts
  flex: 1
  padding 1rem 1.75rem 1.25rem 1.75rem
  @media (max-width: 700px)
    padding-left 0
    padding-right 0

.booking-id
  barlow()
  margin 0
  margin-bottom: 0.5rem

.booking-title
  medium-title()
  margin 0 0

.arrival-date
  barlow()
  margin 0
  margin-top 0.5rem

.booking-checkboxes
  margin 0 auto
  margin-top 2rem
  padding 2rem 7rem
  box-shadow: 10px 20px 40px 0 rgba(0, 0, 0, 0.05)
  z-index 1
  background-color white
  position relative
  @media(max-width 700px)
    padding-left 1.25rem
    padding-right 1.25rem
    margin-top 0
    margin-bottom 2rem

  &.booking-checkboxes--addons
    margin-top 0
    padding-top: 1rem
    box-shadow: none

  .row-wrap
    .row-header
      display flex
      justify-content space-between
      border-bottom 1px solid shadow-blue
      align-items: center
      padding-top 0.75rem
      padding-bottom: 0.75rem
      .checkbox
        width 2rem
      .category
        barlow()
        font-weight 300
        width calc(100% - 10rem)
        text-align: left
        font-size 1.25rem
      .actions
        width 10rem
        text-align: right

.addon-title
  margin-top: 4rem
  margin-left: 7rem
  @media(max-width 700px)
    margin-left 0

.info-box
  background-color: light-blue
  padding 1.5rem
  text-align: center

.qr-button
  margin-top 1rem
  margin-bottom 1rem
  margin-left: 1rem
  @media(min-width 651px)
    margin-top 2rem
    margin-left 3rem
</style>



// WEBPACK FOOTER //
// MyBookingV2.vue?48df32d1